import { createSelector } from "@reduxjs/toolkit";
import { matchesFilterTokens, matchesSectionFilterTokens } from "@src/utils/sectionFilter.utils";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { fromType } from "@src/store/helpers";
import { _selectMapSplitMinQuantity, _selectSelectedRowNames, _selectSelectedSectionNames } from "@src/store/map/mapSlice";
import { RootState } from "@src/store/store";

export interface ActiveTNListing {
	Section: string;
	Row: string;
	Quantity: number;
	TMRRetailPrice: number;
	IsInstantDelivery: boolean;
	IsPDFAvailable: boolean;
	Description: string;
	TicketID: number;
	BrokerID: number;
	QuantitySplitOptions: Array<number>;
}

const initialState = fromType<Array<ActiveTNListing>>([]);

export const { thunk: getTNActiveListings, slice: getTNctiveListingsSlice } = getThunkAndSlice<
	{
		productionId: number;
	},
	typeof initialState
>({
	initialState,
	path: ({ productionId }) => `/api/EventInventory/GetTickets?productionId=${productionId}&page=1&startIndex=0&limit=25`,
	cacheId: "productionId",
});

const selectActiveTNListingsData = (state: RootState) => state.marketplace.ticketsNow.activeTNListings;

export const selectAggregatedTNListings = createSelector(
	[selectActiveTNListingsData, _selectSelectedSectionNames, _selectMapSplitMinQuantity, _selectSelectedRowNames],
	(activeTNListings, selectedSections, minQuantity, selectedRows) => {
		const listingsData = Array.isArray(activeTNListings?.data) ? activeTNListings.data : [];

		const filteredListings =
			listingsData.filter((x) => {
				const isRawSectionIncluded = selectedSections.length > 0 ? matchesSectionFilterTokens(selectedSections, x.Section, x.Row) : true;
				const isRawRowIncluded = selectedRows.length > 0 ? matchesFilterTokens(selectedRows, x.Row) : true;
				const isSplitMinQuantityIncluded = !minQuantity || x.QuantitySplitOptions.includes(+minQuantity);

				return isRawSectionIncluded && isSplitMinQuantityIncluded && isRawRowIncluded;
			}) || [];

		return {
			activeTNLoading: activeTNListings.loading,
			filteredActiveTNListings: filteredListings,
			activeTNListingTotalTickets: filteredListings?.reduce((acc, x) => acc + x.Quantity, 0),
		};
	},
);
